import { render } from "./SuperAdminShell.vue?vue&type=template&id=fd07aedc"
import script from "./SuperAdminShell.vue?vue&type=script&lang=js"
export * from "./SuperAdminShell.vue?vue&type=script&lang=js"

import "./SuperAdminShell.vue?vue&type=style&index=0&id=fd07aedc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__